import { format } from 'date-fns'

import * as api from '../api'
import useApiMutation from './useApiMutation'
import useInvalidate from '../useInvalidate'

export default function useAddUsersToLearningItems() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async ({
      userUuids,
      learningItemsAssignments,
      skipNotifications,
    }: {
      userUuids: string[]
      learningItemsAssignments: {
        uuid: string
        dueDate?: Date
      }[]
      skipNotifications?: boolean
    }) => {
      await api.post('course/assign/learning-items-to-users', {
        users: userUuids,
        skip_notifications: skipNotifications,
        learning_items: learningItemsAssignments.map(({ uuid, dueDate }) => ({
          uuid,
          due_date: dueDate ? format(dueDate, 'yyyy-MM-dd') : undefined,
        })),
      })

      await Promise.all([invalidate.users(), invalidate.courses()])
    },
  })
}
